import { ReactElement } from 'react';
import { IconBadge, IconBadgeBaseProps } from 'components/IconBadge/IconBadge';
import { ReservationState } from '../row/media';

export const RESERVATION_STATE_PROPS: Record<ReservationState, IconBadgeBaseProps> = {
  NONE: {
    title: 'None',
    icon: 'circle-dashed',
    background: 'gray100',
    color: 'gray500',
  },
  BOOKED: {
    title: 'Booked',
    icon: 'book-open',
    background: 'primary',
    color: 'onPrimary',
  },
  ON_AIR: {
    title: 'On Air',
    icon: 'play',
    background: 'success',
    color: 'onSuccess',
  },
  ON_HOLD: {
    title: 'On Hold',
    icon: 'pause',
    background: 'warning',
    color: 'onWarning',
  },
  DONE: {
    title: 'Done',
    icon: 'check',
    background: 'gray100',
    color: 'success',
  },
};

export function ReservationStateBadge({
  reservation_state,
  testId,
}: {
  reservation_state: ReservationState;
  testId?: string;
}): ReactElement {
  return <IconBadge {...RESERVATION_STATE_PROPS[reservation_state]} testId={testId} />;
}
